module.exports = __webpack_public_path__ + "src/images/products/prep/32_Swordfish Print Socks.png";